import { Link } from 'react-router-dom';
import { sportsCategories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-bold text-primary-500">
                BB<span className="text-background-50">体育</span>
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              bb体育是您信赖的专业体育平台，涵盖足球、篮球、网球等热门赛事投注与实时直播。安全稳定，值得信赖。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">热门赛事</h4>
            <ul className="space-y-2">
              {sportsCategories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}赛事直播
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/category/promotions" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">优惠活动</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">联系客服</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="space-y-2 text-sm text-background-400">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>service@bbtiyu.com</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-6666</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-400"></i>
                <span>7×24小时在线客服</span>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} bb体育 版权所有 | 专业体育赛事投注与直播平台
          </p>
          <div className="flex items-center gap-4">
            <a href="https://www.bbtiyu.com/" rel="nofollow" className="w-8 h-8 flex items-center justify-center text-background-500 hover:text-primary-400 transition-colors">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="https://www.bbtiyu.com/" rel="nofollow" className="w-8 h-8 flex items-center justify-center text-background-500 hover:text-primary-400 transition-colors">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="https://www.bbtiyu.com/" rel="nofollow" className="w-8 h-8 flex items-center justify-center text-background-500 hover:text-primary-400 transition-colors">
              <i className="ri-telegram-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}